import * as React from "react";

import { Skeleton } from "./skeleton";

export const LabeledValueSkeleton = (): React.ReactElement => (
  <div
    aria-busy="true"
    aria-label="Loading information"
    data-slot="labeled-value-skeleton"
    className="space-y-1.5"
  >
    <Skeleton className="h-5 w-full" />
    <Skeleton className="h-4 w-24" />
  </div>
);
